import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "advertiser/products";
const options = { role: ROLE.ADVERTISER };

export const CreateProduct = async (values) => {
  return await axiosInstance(options).post(`${path}/create-product`, values);
};
export const ListProduct = async (values) => {
  return await axiosInstance(options).post(`${path}/product-list`, values);
};
export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/product-details?o_id=${id}`);
}
export const UpdateProduct = async (values) => {
  return await axiosInstance(options).put(`${path}/update-product`, values);
}
export const DeleteProduct = async (id) => {
  return await axiosInstance(options).post(`${path}/product-delete?o_id=${id}`);
}
export const StreamOptions = async () => {
  return await axiosInstance(options).get(`${path}/get-streams-options`);
}
export const AnalyzeProductImage = async (image) => {
  return await axiosInstance(options).post(`${path}/analyze-product-image`, { image });
}
export const BulkCreateProducts = async (products) => {
  return await axiosInstance(options).post(`${path}/bulk-create-products`, { products });
}
export const TogglePublishProduct = async (data) => {
  return await axiosInstance(options).put(`${path}/toggle-publish`, data);
}

